/** V2 — Moteur d'étapes adaptatif : la liste des écrans dépend des réponses. */
import { BIEN_IDENTIFIE } from "./simConstants";

const num = (v) => (v === "" || v == null) ? 0 : Number(v);

/** Écrans de questions (hors landing / computing / coords / résultat), dans l'ordre. */
export function questionSteps(d) {
  const s = ["maturity", "destination"];
  const m = d.maturity;
  const bien = BIEN_IDENTIFIE.has(m);
  if (m && m !== "reflexion") s.push("type_bien");
  s.push("localisation_projet"); // facultatif en réflexion/recherche, obligatoire si bien identifié
  if (m === "recherche") s.push("prix_cible");
  if (bien) s.push("prix_bien");
  if (bien && d.type_bien !== "neuf") s.push("travaux");
  if (bien && d.type_bien === "ancien") s.push("dpe");
  if (m === "compromis") s.push("dates_compromis");
  s.push("foyer", "profil_e1", "revenus_e1");
  if (d.nb_emprunteurs === 2) s.push("profil_e2", "revenus_e2");
  s.push("autres_revenus", "logement", "credits", "pension", "apport");
  return s;
}

/** Parcours complet (avec écrans techniques). */
export function fullSteps(d) {
  return ["landing", ...questionSteps(d), "computing", "coords", "result", "callback_confirm", "callback_done", "qualif", "qualif_end"];
}

export function nextStep(d) {
  const steps = fullSteps(d);
  const i = steps.indexOf(d.stepKey);
  return steps[Math.min(steps.length - 1, i + 1)];
}

export function prevStep(d) {
  const steps = fullSteps(d);
  const i = steps.indexOf(d.stepKey);
  return steps[Math.max(0, i - 1)];
}

export function progress(d) {
  const q = questionSteps(d);
  const i = q.indexOf(d.stepKey);
  if (i < 0) return { index: 0, total: q.length, pct: d.stepKey === "landing" ? 0 : 100 };
  return { index: i + 1, total: q.length, pct: Math.round(((i + 1) / q.length) * 100) };
}

/** Sérialisation vers SimulationInputs (backend). */
export function buildInputs(d) {
  const emp = (e) => ({
    situation_pro: e.situation_pro || "autre",
    revenus_nets_mensuels: num(e.revenus_nets_mensuels),
    age: e.age !== "" && e.age != null ? Number(e.age) : null,
    periode_essai: e.periode_essai,
    titulaire: e.titulaire,
    anciennete: e.anciennete,
    autre_detail: e.autre_detail,
    revenus_variables: e.revenus_variables,
    revenus_variables_montant: e.revenus_variables ? num(e.revenus_variables_montant) : 0,
  });
  const bien = BIEN_IDENTIFIE.has(d.maturity);
  return {
    schema_version: 2,
    maturity: d.maturity,
    destination: d.destination,
    type_bien: d.type_bien || null,
    prix_bien: bien && d.prix_bien ? Number(d.prix_bien) : null,
    prix_cible: d.maturity === "recherche" && d.prix_cible ? Number(d.prix_cible) : null,
    projet_ville: d.projet_ville || null,
    projet_code_postal: d.projet_code_postal || null,
    travaux_prevus: bien ? d.travaux_prevus : null,
    travaux_montant: bien && d.travaux_prevus ? num(d.travaux_montant) : 0,
    dpe: bien && d.type_bien === "ancien" ? d.dpe : null,
    compromis_date: d.maturity === "compromis" && d.compromis_date ? d.compromis_date : null,
    condition_suspensive_date: d.maturity === "compromis" && !d.cs_inconnue && d.condition_suspensive_date ? d.condition_suspensive_date : null,
    nb_emprunteurs: d.nb_emprunteurs || 1,
    nb_enfants: d.nb_enfants || 0,
    emprunteur_1: emp(d.emprunteur_1),
    emprunteur_2: d.nb_emprunteurs === 2 ? emp(d.emprunteur_2) : null,
    autres_revenus: d.has_autres_revenus ? {
      locatifs: num(d.autres_revenus.locatifs), pensions: num(d.autres_revenus.pensions), rentes: 0, primes: 0, autres: num(d.autres_revenus.autres),
    } : null,
    logement_statut: d.logement_statut,
    loyer_actuel: d.logement_statut === "locataire" ? num(d.loyer_actuel) : 0,
    bien_actuel: d.logement_statut === "proprietaire" ? d.bien_actuel : null,
    credits: d.has_credits ? (d.credits || []).map((c) => ({
      type: c.type || "consommation", mensualite: num(c.mensualite), fin_moins_12m: c.fin_moins_12m ?? null,
      crd: c.type === "immobilier" && c.crd ? Number(c.crd) : null,
    })) : [],
    pension_alimentaire: d.has_pension ? num(d.pension_alimentaire) : 0,
    autres_charges: d.has_pension ? num(d.autres_charges) : 0,
    apport: num(d.apport),
    epargne_conservee: 0,
    epargne_residuelle: d.epargne_residuelle,
    residence_ville: d.coords.residence_ville || null,
    residence_code_postal: d.coords.residence_code_postal || null,
  };
}
